import React, { Component, PropTypes } from 'react';
import { SubmissionError } from 'redux-form';
import Attribute from 'marketing/common/attribute';
import { Meta } from 'common/components/meta';
import { createReferralsRequest } from 'marketing/ducks';
import Form from 'marketing/components/refer_a_friend_form';
import {
  REFERRAL_MONEY_DISCOUNT, REFERRAL_FEATURE_DISCOUNT, REFERRAL_TOTAL_DISCOUNT
} from 'marketing/constants';
import Share from 'marketing/containers/refer_a_friend_share';

export default class ReferAFriend extends Component {
  constructor(props) {
    super(props);

    this.state = { done: false };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchReferrals();
  }

  handleSubmit(data) {
    return createReferralsRequest(data).then(() => {
      this.setState({ done: true });
    }).catch((res) => {
      throw new SubmissionError({_error: 'Unknown error. Please try again.'});
    })
  }

  render() {
    const { referrals, billingName } = this.props;

    return (
      <div className="l-content refer-a-friend" id="content">
        <Meta title="Refer a friend" meta={[{ name: "robots", content: "noindex,nofollow" }]} />

        <div className="row">
          { this.state.done?
          <div className="columns large-8 small-16 done text-center align-middle">
            <h1>
              <i className="fa fa-2x fa-check-circle text-success" /><br/>
              Thanks!
            </h1>
          </div> :
          <div className="columns large-8 small-16">
            <h1>Help a friend and you both win!</h1>
            <p className="intro">
              When a person you refer posts their project, both you and your friend
              get {REFERRAL_MONEY_DISCOUNT} off a future project plus
              our {REFERRAL_FEATURE_DISCOUNT} for free (total value: {REFERRAL_TOTAL_DISCOUNT}).
              There's no limit to how many referrals you can send - you benefit from each project
              posted by people you refer.
            </p>

            <Form onSubmit={this.handleSubmit} referrals={referrals}
              initialValues={{ client_name: billingName }} />

            <Share />
          </div> }
          <div className="columns large-8 small-16 image-container">
            <img src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_cta2-2x.png" alt="crowdspring image designed by abu_hilmi"/>
          </div>
        </div>
      </div>
    );
  }
}

ReferAFriend.propTypes = {
  billingName: PropTypes.string,
  referrals: PropTypes.array.isRequired,
  fetchReferrals: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./marketing/components/refer_a_friend.jsx